import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTableTextClamp]',
  standalone: true,
})
export class TableTextClampDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const table = this.el.nativeElement as HTMLElement;
    const cells = table.querySelectorAll('td');

    cells.forEach(cell => {
      const children = Array.from(cell.childNodes);

      const isTextOrSpanOnly = children.every(node =>
        node.nodeType === Node.TEXT_NODE ||
        (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'SPAN')
      );

      if (isTextOrSpanOnly) {
        const fullText = cell.textContent?.trim() ?? '';
        if (!fullText) return;

        // Create a wrapper div
        const wrapper = this.renderer.createElement('div');
        this.renderer.setStyle(wrapper, 'display', '-webkit-box');
        this.renderer.setStyle(wrapper, '-webkit-line-clamp', '2');
        this.renderer.setStyle(wrapper, '-webkit-box-orient', 'vertical');
        this.renderer.setStyle(wrapper, 'overflow', 'hidden');
        this.renderer.setStyle(wrapper, 'text-overflow', 'ellipsis');
        this.renderer.setStyle(wrapper, 'white-space', 'normal');
        this.renderer.setStyle(wrapper, 'cursor', 'pointer');
        this.renderer.setAttribute(wrapper, 'title', fullText);

        // Move child nodes into the wrapper
        children.forEach(child => this.renderer.appendChild(wrapper, child));
        this.renderer.appendChild(cell, wrapper);
      }
    });
  }
}
